<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChevronDown_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M7.41 10.749 3.245 6.463a.873.873 0 0 1 0-1.212.816.816 0 0 1 1.179 0L8 8.931l3.577-3.68a.816.816 0 0 1 1.179 0 .873.873 0 0 1 0 1.212L8.589 10.75a.816.816 0 0 1-1.178 0Z"
    />
</svg>
